module.exports = __webpack_public_path__ + "static/img/textlogo.464944d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/textlogo.png
// module id = sUHb
// module chunks = 1